import getRemainingDays from "../../../utils/getRemainingDays";

class License {
  /** Дата окончания действия лицензии */
  endDate;

  /** Количество оставшихся дней до окончания лицензии */
  remainingDays;

  /** Является ли лицензия частью уже купленного пакета лицензий */
  isDependent;

  /** Триальная ли лицензия */
  isTrial;

  /** Количественный параметр лицензии. Например, лицензия куплена на 10 контактов */
  serviceAmount;

  /** id лицензии */
  serviceId;

  /** Название лицензии */
  serviceName;

  /** Обозначает является ли лицензия сервисом биллинга */
  irregular;

  constructor({
    end_date,
    is_dependent,
    is_trial,
    service_amount,
    service_id,
    service_name,
    irregular,
  }) {
    this.endDate = end_date;
    this.remainingDays = getRemainingDays(end_date);
    this.isDependent = is_dependent;
    this.isTrial = is_trial;
    this.serviceAmount = service_amount;
    this.serviceId = service_id;
    this.serviceName = service_name;
    this.irregular = irregular;
  }
}

export default License;
